import * as React from 'react'
import type { SVGProps } from 'react'
const SvgSnapchat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.665 16.763c-1.96-.51-3.46-1.689-4.22-3.31 0 0 0-.004.004-.007l1.825-1.422c.416-.325.583-.88.416-1.381a1.252 1.252 0 0 0-1.413-.833l-1.276.229c.35-2.14-.068-4.04-1.177-5.349C14.902 3.6 13.543 3 12 3s-2.902.6-3.825 1.691c-1.11 1.31-1.527 3.21-1.17 5.364-.546-.099-1.274-.237-1.274-.237a1.242 1.242 0 0 0-1.422.827c-.167.5 0 1.053.416 1.377l1.833 1.422c-.764 1.63-2.263 2.81-4.223 3.32L2 16.85l.025.347c.026.344.156.619.386.815.472.404 1.209.34 1.857.284.273-.024.683-.06.757-.037.316.396.325.986.325.99v.417h2.078c.458 0 1.04.322 1.658.664.85.47 1.812 1.002 2.914 1.002s2.065-.532 2.914-1.002c.617-.342 1.2-.664 1.658-.664l2.075-.002.003-.413c0-.006.01-.596.291-.961.107-.053.519-.017.79.006.649.055 1.386.12 1.858-.284.23-.196.36-.47.386-.815L22 16.85l-.335-.088z"
    />
  </svg>
)
export default SvgSnapchat
